import React from 'react';
const Megaphone = (props: React.SVGProps<SVGSVGElement>) =>
(
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M9.33333 9.33356V4.00023M9.33333 9.33356L13.4013 11.6582C13.4621 11.693 13.531 11.7112 13.601 11.711C13.6711 11.7109 13.7398 11.6923 13.8004 11.6572C13.8611 11.6221 13.9114 11.5717 13.9464 11.511C13.9814 11.4504 13.9999 11.3816 14 11.3116V2.02223C14 1.95213 13.9816 1.88326 13.9467 1.82251C13.9117 1.76176 13.8614 1.71126 13.8007 1.67608C13.7401 1.64091 13.6713 1.62228 13.6012 1.62207C13.5311 1.62186 13.4622 1.64008 13.4013 1.67489L9.33333 4.00023M9.33333 9.33356H4.66667M9.33333 4.00023H4.66667C3.95942 4.00023 3.28115 4.28118 2.78105 4.78128C2.28095 5.28137 2 5.95965 2 6.66689C2 7.37414 2.28095 8.05241 2.78105 8.55251C3.28115 9.05261 3.95942 9.33356 4.66667 9.33356M4.66667 9.33356L5.17133 12.8669C5.22399 13.2107 5.41019 13.5198 5.68946 13.727C5.96873 13.9343 6.31851 14.0229 6.66279 13.9738C7.00707 13.9246 7.31803 13.7415 7.5281 13.4644C7.73817 13.1872 7.83037 12.8383 7.78467 12.4936L7.33333 9.33356H4.66667Z"
            stroke="currentColor" strokeWidth="1.6" />
    </svg>
);
export default Megaphone;
